import { useState } from "react";
import { Button, Collapse, Space  } from 'antd';
import { Tag } from '../../components/Tag';
import { ModalEquipeEditar } from '../../components/Modal/equipeeditar';


interface Props {
  open:boolean;
  onClose: ()=>void;
}

export const ModalEquipeDetalhe = (props: Props) =>{
  const { open, onClose } = props;
  const { Panel } = Collapse;

  const [isOpen, setIsOpen] = useState(false);

  const onChangeModal = () => {
    if(isOpen===true){
      setIsOpen(false)
    }else{
      setIsOpen(true)
    }
  }

  const onClose1 = () => {
    setIsOpen(false)
  }


  if (!open) return null

  return(
    <>
      <div className="flex flex-row justify-center align-center modal-container">
        <div className="flex flex-column justify-start align-start modal">
          <Button onClick={onClose} className="button-x">x</Button>
          <h3 >Detalhes da Equipe</h3>
          <Space direction="vertical">
            <Collapse collapsible="header" defaultActiveKey={['1']}>
              <Panel header="Dados da equipe" key="1">
                <div className='flex flex-row'>
                  <div className="w-50">
                    <h6>Nome</h6>
                    <h4>Alphaville/SP</h4>
                  </div>
                  <div className="w-50">
                    <h6>Grupo</h6>
                    <h4>Happy Brasil</h4>
                  </div>
                </div>
              </Panel>
            </Collapse>
            <Collapse collapsible="header">
              <Panel header="Páginas" key="2">
                <Tag icon="facebook" text="facebook.com/happycodealphaville" />
              </Panel>
            </Collapse>
            <Collapse collapsible="header">
              <Panel header="Usuarios" key="3">
                <div className="flex flex-row justify-start alingn-center flex-wrap">
                  <Tag icon="user" text="Alexandre Dias" />
                  <Tag icon="user" text="Alexandra Lima" />
                  <Tag icon="user" text="Rebeca Souza" />
                  <Tag icon="user" text="Jose A. Junior" />
                  <Tag icon="user" text="Diego Teixeira" />
                  <Tag icon="user" text="Barbar Gomes" />
                  <Tag icon="user" text="Thaila Torres" />
                  <Tag icon="user" text="Paulo A. Lopes" />
                  <Tag icon="user" text="Tiago Fernandez" />
                </div>
              </Panel>
            </Collapse>
          </Space>
          <div className="flex flex-row justify-end w-100 mt-20">
            <Button onClick={onChangeModal}  className="button-blue mr-5">Editar</Button>
            <Button onClick={onClose}  className="button-primary">Oka</Button>
          </div>
        </div>
      </div>
      <ModalEquipeEditar
        open={isOpen}
        onClose={onClose1}
      />
    </>
  )
}
